import React, { useContext, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { Grid } from "@mui/material";
import { AppContext } from "../../context/AppProvider";
import { ActivationForm } from "./Form";

export const Activation = (props) => {
  const { activation, license } = useContext(AppContext);
  const { customer, startDate, endDate, type, sku } = activation;

  const navigate = useNavigate();

  useEffect(() => {
    if (license.key) {
      navigate("/license");
    }
  }, [license.key, navigate]);

  return (
    <Grid container>
      <Grid item md={6} className="form">
        <ActivationForm />
      </Grid>

      <Grid item md={6} className="summary">
        <div className="summary-holder">
        <div className="summary-box">
            <div className="title">License Information</div>
            {!customer ? (
              <p>Enter the installation ID and Activation key to see details about the license</p>
            ) : (
              <div className="summary-table" style={{padding: '20px 0 0'}}>
              <div className="line"><span>Issued to:</span><span className="details">{customer || ""}</span></div>
              <div className="line"><span>Start Date:</span><span className="details">{startDate || ""}</span></div>
              <div className="line"><span>End Date:</span><span className="details">{endDate || ""}</span></div>
              <div className="line"><span>Type:</span><span className="details">{type || ""}</span></div>
              <div className="line"><span>SKU:</span><span className="details">{sku || ""}</span></div>
              </div>
            )}
            
          </div>

        </div>
      </Grid>
    </Grid>
  );
}